/**
 * A dummy upload service that simulates an API call
 * and returns a fake URL for the uploaded file.
 */
export const uploadFile = async (file: File): Promise<string> => {
  // Simulate an API call
  await new Promise((resolve) => setTimeout(resolve, 1000));
  // Return a dummy URL
  return `https://fake-upload-service.com/${file.name}`;
};
